import {WaitingStatus} from '@web/core/constants'

import {WaitingState} from '../interfaces'

export const getInitialState = (): WaitingState => ({
    status: WaitingStatus.INITIALIZED,
    ticketId: '',
    enterable: false,
    expelled: false,
    expelledReason: null,
    expired: false,
    globalSubTicket: {
        waitNumber: 0,
    },
    globalWaitQueue: {
        bandwidth: 0,
        lastEnterableWaitNumber: 0,
        lastWaitNumber: 0,
        queueActive: false,
    },
    memberId: '',
    fetchTicketRetryTimes: 0,
    socketAuthUrl: '',
    socketChannelNames: [],
    subTicketAndWaitQueueList: [
        {
            enterable: false,
            queueId: '',
            subTicket: {
                waitNumber: 0,
            },
            waitQueue: {
                bandwidth: 0,
                lastEnterableWaitNumber: 0,
                lastWaitNumber: 0,
                queueActive: false,
            },
        },
    ],
    ticket: null,
    queue: null,
    version: null,
    expelReason: null,
})
